<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    destroyOnClose
    :visible="visible"
  >
    <a-card
      :headStyle="{ 'text-align': 'center' }"
      :title="'分析报告【' + (model.reportStatus === 1 ? '已完结' : '编制中') + '】'"
      size="small"
    >
      <a-form-model :model="model" :rules="rules" ref="form">
        <a-row>
          <a-col :md="24" :sm="24">
            <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" label="事件名称" prop="reportname">
              <a-input :disabled="disabled" v-model="model.reportName" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="24" :sm="24">
            <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" label="登记人" prop="manager">
              <a-input
                :defaultValue="this.$store.getters.userInfo.realname"
                :disabled="disabled"
                v-model="model.manager"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="8" :sm="8">
            <a-form-model-item
              :labelCol="{ span: 12 }"
              :wrapperCol="{ span: 12 }"
              label="是否有效预警"
              prop="effective"
            >
              <j-switch v-model="model.effective" :disabled="disabled" :options="[1, 0]"></j-switch>
            </a-form-model-item>
          </a-col>

          <a-col :md="16" :sm="16">
            <a-form-model-item :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }" label="影响程度" prop="impact">
              <a-radio-group :disabled="disabled" button-style="solid" v-model="model.impact">
                <a-radio-button value="0">无影响</a-radio-button>
                <a-radio-button value="1">较低</a-radio-button>
                <a-radio-button value="2">一般</a-radio-button>
                <a-radio-button value="3">较高</a-radio-button>
                <a-radio-button value="4">极高</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="24" :sm="24">
            <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" label="事件描述" prop="description">
              <a-textarea :auto-size="{ minRows: 4 }" :disabled="disabled" v-model="model.description" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="24" :sm="24">
            <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" label="可能原因" prop="PossibleCause">
              <a-textarea :auto-size="{ minRows: 3 }" :disabled="disabled" v-model="model.possibleCause" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="24" :sm="24">
            <a-form-model-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" label="处理建议" prop="Suggest">
              <a-textarea :auto-size="{ minRows: 3 }" :disabled="disabled" v-model="model.suggest" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-divider style="margin-top: 10px" />

        <a-row>
          <a-col :md="24" :sm="24">
            <a-form-model-item
              :labelCol="{ span: 4 }"
              :wrapperCol="{ span: 18 }"
              label="现场反馈"
              prop="feedback"
              ref="feedback"
            >
              <a-textarea :auto-size="{ minRows: 4 }" :disabled="disabled" v-model="model.feedback" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <div class="drawer-footer">
      <a-button @click="handleCancel" style="margin-bottom: 0;">关闭</a-button>
      <a-button
        v-if="!disableSubmit"
        :disabled="disabled"
        @click="handleSubmit(0)"
        type="primary"
        style="margin-bottom: 0;"
        >保存</a-button
      >
      <a-button
        v-if="!disableSubmit"
        :disabled="disabled"
        @click="handleSubmit(1)"
        type="primary"
        style="margin-bottom: 0;"
        >完结</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import IotModelEventReportForm from './IotModelEventReportForm'
import moment from 'dayjs'
import { httpAction, getAction } from '@/api/manage'

export default {
  name: 'IotModelEventReportModal',
  components: {
    IotModelEventReportForm
  },
  data() {
    return {
      title: '事件报告',
      width: 800,
      visible: false,
      disableSubmit: false,
      alertInfo: {},
      model: {},
      url: {
        list: '/monitor/eventReport/list',
        add: '/monitor/eventReport/add',
        edit: '/monitor/eventReport/edit'
      },
      rules: {
        reportName: [{ required: true, message: '请输入事件名称!' }],
        manager: [{ required: true, message: '请输入登记人!' }],
        description: [{ required: true, message: '请输入事件详情!' }]
      }
    }
  },
  computed: {
    disabled() {
      return this.disableSubmit || this.model.reportStatus === 1
    }
  },
  methods: {
    handleSubmit(type) {
      this.$refs.form.validate((ok, err) => {
        if (ok) {
          if (this.alertInfo.isRecovery != 1) {
            this.$message.error('未恢复的预警事件无法完结，请及时联系现场处理！')
            return
          }
          if (type === 1 && !this.model.feedback) {
            this.$message.error('必须录入【现场反馈】才可以完结！')
            return
          }

          const saveParms = Object.assign(this.model, { reportStatus: type })

          let httpurl = ''
          let method = ''
          if (!saveParms.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, saveParms, method).then(res => {
            if (res.success) {
              this.$message.success('成功保存')
              this.getReportInfo()
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      })
    },
    getReportInfo() {
      getAction(this.url.list, { id: this.alertInfo.reportId }).then(res => {
        if (res.success) {
          this.model = res.result.records[0]
          this.model.impact = this.model.impact + ''
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    edit(record) {
      this.visible = true
      const defaultModel = {
        effective: true,
        manager: this.$store.getters.userInfo.realname
      }
      this.$nextTick(() => {
        this.alertInfo = Object.assign({}, record)
        if (record.reportId) {
          this.getReportInfo()
        } else {
          const props = {
            impact: '2',
            alertId: record.id,
            description: record.summary,
            reportName: `${record.alertName || record.devId_dictText} - 告警分析报告 【${moment(
              record.alertTime
            ).format('YYYYMMDDHHmmss')}】`
          }
          this.model = Object.assign({}, defaultModel, props)
        }
      })
    },
    close() {
      this.model = {}
      this.$emit('close')
      this.visible = false
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
/** Button按钮间距 */
.ant-btn {
  margin-left: 30px;
  margin-bottom: 30px;
  float: right;
}
.drawer-footer {
  position: absolute;
  bottom: 0px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
